import { content } from "../../config/content.js";
import { buildAnimatedHeading } from "../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../components/SectionPill.js";
import {
  buildTeamAvatarRef,
  buildTeamAvatarSprite,
  experienceLabel,
} from "../components/TeamAvatar.js";

/* Both marquee copies draw from one set of definitions. */
const SCOPE = "team";

function renderCard(member, index) {
  return `
    <article class="team-card">
      <div class="team-card__photo">
        ${buildTeamAvatarRef(member, index, SCOPE)}
        <span class="team-card__exp">${experienceLabel(member)}</span>
      </div>
      <div class="team-card__info">
        <span class="team-card__role">${member.role}</span>
        <h3 class="team-card__name">${member.name}</h3>
        <ul class="team-card__tags">
          ${member.tags.map((tag) => `<li>${tag}</li>`).join("")}
        </ul>
      </div>
    </article>
  `;
}

function renderGroup(members, { hidden = false } = {}) {
  return `
    <div class="team__group"${hidden ? ' aria-hidden="true"' : ""}>
      ${members.map(renderCard).join("")}
    </div>
  `;
}

export function createTeamSection() {
  const { team } = content;
  const section = document.createElement("section");
  section.id = "team";
  section.className = "section team";

  section.innerHTML = `
    ${buildTeamAvatarSprite(team.members, SCOPE)}

    <div class="section__inner team__inner">
      <div class="team__intro reveal">
        ${buildSectionPillRow(team.badge)}
        <h2 class="team__title">${buildAnimatedHeading(team.titleSegments)}</h2>
        <p class="team__subtitle">${team.subtitle}</p>
      </div>
    </div>

    <div class="team__marquee reveal">
      <div class="team__viewport">
        <div class="team__track">
          ${renderGroup(team.members)}
          ${renderGroup(team.members, { hidden: true })}
        </div>
      </div>
    </div>
  `;

  return section;
}
